import { createAction } from "@ngrx/store";

import { AppError } from "./app-error.model";

const ACTION_PREFIX = "[App Error]";

export namespace AppErrorAction {
	export const badRequestError = createAction(`${ACTION_PREFIX} Bad Request Error`, (appError: AppError) => ({
		payload: appError,
	}));

	export const unauthorizedError = createAction(`${ACTION_PREFIX} Unauthorized Error`, (appError: AppError) => ({
		payload: appError,
	}));

	export const serverError = createAction(`${ACTION_PREFIX} Server Error`, (appError: AppError) => ({
		payload: appError,
	}));

	export const unhandledError = createAction(`${ACTION_PREFIX} Unhandled Error`, (appError: AppError) => ({
		payload: appError,
	}));
}
